import type { SVGProps } from "react";

type IconProps = SVGProps<SVGSVGElement> & { size?: number };

function base({ size = 24, ...props }: IconProps) {
  return {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
  };
}

const s = {
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round" as const,
  strokeLinejoin: "round" as const,
};

// ── Activity / Health ──
export function Activity({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M3 12h4l3-8 4 16 3-8h4" {...s} /></svg>;
}
export function HeartPulse({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M3 12h3l2-5 3 10 2-5h2l1 3h2" {...s} /><path d="M12 20s-7-4.5-7-10a4 4 0 0 1 7-2.5A4 4 0 0 1 19 10c0 5.5-7 10-7 10z" {...s} opacity={0.3} /></svg>;
}
export function Heart({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M12 20s-7-4.5-7-10a4 4 0 0 1 7-2.5A4 4 0 0 1 19 10c0 5.5-7 10-7 10z" {...s} /></svg>;
}
export function Stethoscope({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M5 3v6a4 4 0 0 0 8 0V3" {...s} /><path d="M9 13v3a5 5 0 0 0 10 0v-2" {...s} /><circle cx="19" cy="11" r="2" {...s} /></svg>;
}
export function Pill({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><rect x="3" y="9" width="18" height="6" rx="3" transform="rotate(-45 12 12)" {...s} /><path d="M9 9l6 6" {...s} /></svg>;
}
export function Syringe({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M18 2l4 4M16 4l4 4M14 6l-8 8M6 14l-2 4 4-2M10 10l4 4" {...s} /></svg>;
}
export function Brain({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M9 3a3 3 0 0 0-3 3v1a3 3 0 0 0-2 3v1a3 3 0 0 0 2 3v1a3 3 0 0 0 3 3h1V3z" {...s} /><path d="M15 3a3 3 0 0 1 3 3v1a3 3 0 0 1 2 3v1a3 3 0 0 1-2 3v1a3 3 0 0 1-3 3h-1V3z" {...s} /></svg>;
}
export function Droplet({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M12 3s-6 7-6 11a6 6 0 0 0 12 0c0-4-6-11-6-11z" {...s} /></svg>;
}
export function Droplets({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M7 3s-4 5-4 8a4 4 0 0 0 8 0c0-3-4-8-4-8z" {...s} /><path d="M17 9s-3 4-3 6a3 3 0 0 0 6 0c0-2-3-6-3-6z" {...s} opacity={0.5} /></svg>;
}
export function ScanLine({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M4 4v3M4 4h3M20 4v3M20 4h-3M4 20v-3M4 20h3M20 20v-3M20 20h-3" {...s} /><path d="M4 12h16" {...s} opacity={0.4} /></svg>;
}
export function Siren({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M7 13a5 5 0 0 1 10 0v5H7z" {...s} /><path d="M12 8V5M5 18h14" {...s} /><path d="M12 3v2" {...s} opacity={0.4} /></svg>;
}
export function Sprout({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M12 20v-8M12 12c0-3 2-5 5-5M12 12c0-3-2-5-5-5" {...s} /><path d="M12 20h-3" {...s} opacity={0.4} /></svg>;
}
export function FlaskConical({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M9 3h6v5l5 10a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1L9 8z" {...s} /><path d="M9 3h6" {...s} /><path d="M7 14h10" {...s} opacity={0.4} /></svg>;
}
export function Baby({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><circle cx="12" cy="6" r="2.5" {...s} /><path d="M9 10c1 1 4 1 6 0M8 14c0 2 2 4 4 4s4-2 4-4" {...s} /><path d="M9 6l-1-1M15 6l1-1" {...s} opacity={0.4} /></svg>;
}
export function Ruler({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><rect x="2" y="8" width="20" height="8" rx="1" transform="rotate(-45 12 12)" {...s} /><path d="M8 8l2 2M11 5l2 2M14 8l2 2M8 14l2 2" {...s} opacity={0.4} /></svg>;
}
export function Weight({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M7 8h10l2 12H5z" {...s} /><circle cx="12" cy="5" r="2" {...s} /><path d="M12 7v1" {...s} /></svg>;
}
export function CalendarDays({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><rect x="3" y="5" width="18" height="16" rx="2" {...s} /><path d="M3 9h18M8 3v4m8-4v4" {...s} /><path d="M7 13h2v2H7zM11 13h2v2h-2zM7 17h2v2H7zM11 17h2v2h-2zM15 13h2v2h-2z" {...s} opacity={0.5} /></svg>;
}

// ── Alerts / Status ──
export function AlertCircle({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><circle cx="12" cy="12" r="9" {...s} /><path d="M12 8v5M12 16v.5" {...s} /></svg>;
}
export function AlertTriangle({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M12 3l9 16H3z" {...s} /><path d="M12 9v5M12 17v.5" {...s} /></svg>;
}
export function ShieldCheck({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M12 3l8 3v5c0 5-3.5 8-8 10-4.5-2-8-5-8-10V6l8-3z" {...s} /><path d="M8.5 12l2.5 2.5 4.5-5" {...s} /></svg>;
}
export function ShieldAlert({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M12 3l8 3v5c0 5-3.5 8-8 10-4.5-2-8-5-8-10V6l8-3z" {...s} /><path d="M12 8v4M12 15.5v.5" {...s} /></svg>;
}
export function Shield({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M12 3l8 3v5c0 5-3.5 8-8 10-4.5-2-8-5-8-10V6l8-3z" {...s} /></svg>;
}
export function CheckCircle2({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><circle cx="12" cy="12" r="9" {...s} /><path d="M8 12l3 3 5-6" {...s} strokeWidth={2} /></svg>;
}
export function XCircle({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><circle cx="12" cy="12" r="9" {...s} /><path d="M9 9l6 6M15 9l-6 6" {...s} /></svg>;
}
export function Check({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M5 12l5 5L20 7" {...s} strokeWidth={2} /></svg>;
}
export function CheckCheck({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M2 12l4 4 6-8M10 12l4 4 8-10" {...s} /></svg>;
}
export function X({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M6 6l12 12M18 6L6 18" {...s} /></svg>;
}
export function Info({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><circle cx="12" cy="12" r="9" {...s} /><path d="M12 11v5M12 8v.5" {...s} /></svg>;
}
export function Loader2({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M12 3a9 9 0 1 0 9 9" {...s} /><path d="M12 3v3M12 18v3" {...s} opacity={0.4} /></svg>;
}
export function Clock({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><circle cx="12" cy="12" r="9" {...s} /><path d="M12 7v5l3 2" {...s} /></svg>;
}
export function Timer({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M10 2h4M12 6v4M8 10a6 6 0 1 0 8 0" {...s} /><path d="M12 14v2" {...s} opacity={0.4} /></svg>;
}
export function Ban({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><circle cx="12" cy="12" r="9" {...s} /><path d="M6 6l12 12" {...s} /></svg>;
}
export function Lock({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><rect x="5" y="11" width="14" height="10" rx="2" {...s} /><path d="M8 11V8a4 4 0 0 1 8 0v3" {...s} /></svg>;
}
export function Unlock({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><rect x="5" y="11" width="14" height="10" rx="2" {...s} /><path d="M8 11V8a4 4 0 0 1 8 0" {...s} /></svg>;
}
export function KeyRound({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><circle cx="8" cy="15" r="4" {...s} /><path d="M11 12l8-8M17 5l2 2M14 8l2 2" {...s} /></svg>;
}
export function IdCard({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><rect x="3" y="5" width="18" height="14" rx="2" {...s} /><circle cx="8" cy="11" r="2" {...s} /><path d="M5 16c0-2 2-3 3-3s3 1 3 3M13 9h5M13 12h5M13 15h3" {...s} /></svg>;
}

// ── Arrows ──
export function ArrowUpRight({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M7 17L17 7M17 7H8M17 7v9" {...s} /></svg>;
}
export function ArrowDownRight({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M7 7l10 10M17 17H8M17 17V8" {...s} /></svg>;
}
export function ArrowDownLeft({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M17 7L7 17M7 17v-9M7 17h9" {...s} /></svg>;
}
export function ArrowRight({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M5 12h14m-6-6l6 6-6 6" {...s} /></svg>;
}
export function ArrowLeft({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M19 12H5m6 6l-6-6 6-6" {...s} /></svg>;
}
export function ArrowDown({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M12 5v14m6-6l-6 6-6-6" {...s} /></svg>;
}
export function ArrowRightLeft({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M8 3l4 4-4 4M16 21l-4-4 4-4M4 7h8M20 17h-8" {...s} /></svg>;
}
export function ArrowUpDown({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M7 3v18M4 6l3-3 3 3M17 21V3M14 18l3 3 3-3" {...s} /></svg>;
}
export function ChevronRight({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M9 6l6 6-6 6" {...s} strokeWidth={1.8} /></svg>;
}
export function ChevronLeft({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M15 6l-6 6 6 6" {...s} strokeWidth={1.8} /></svg>;
}
export function ChevronDown({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M6 9l6 6 6-6" {...s} strokeWidth={1.8} /></svg>;
}
export function ChevronsUpDown({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M7 7l5 5 5-5M7 13l5 5 5-5" {...s} /></svg>;
}
export function MoreVertical({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><circle cx="12" cy="5" r="1.5" fill="currentColor" /><circle cx="12" cy="12" r="1.5" fill="currentColor" /><circle cx="12" cy="19" r="1.5" fill="currentColor" /></svg>;
}
export function RotateCcw({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M3 8a9 9 0 1 1-1 5M3 8v5M3 8h5" {...s} /></svg>;
}
export function RefreshCw({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M21 12a9 9 0 0 1-9 9M3 12a9 9 0 0 1 9-9M21 12V8M21 12h-4M3 12v4M3 12h4" {...s} /></svg>;
}
export function RefreshCcw({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M3 12a9 9 0 0 0 9 9M21 12a9 9 0 0 0-9-9M3 12V8M3 12h4M21 12v4M21 12h-4" {...s} /></svg>;
}

// ── Buildings / Places ──
export function Building2({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M4 21V5a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v16M15 21V9h3a2 2 0 0 1 2 2v10M7 7h2m-2 4h2m-2 4h2m4-8h2m-2 4h2M3 21h18" {...s} /></svg>;
}
export function Landmark({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M3 21h18M5 21V10M19 21V10M5 10l7-5 7 5M9 21v-7h6v7M3 10h18" {...s} /></svg>;
}
export function SchoolBuilding({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}>
    <path d="M4 20h16M6 20V8h12v12M4 8l8-4 8 4M9 20v-5h6v5" {...s} />
    <path d="M9 11h1m4 0h1m-6 2h1m4 0h1" {...s} />
  </svg>;
}
export function School({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M2 9l10-4 10 4-10 4-10-4z" {...s} /><path d="M6 11v5c0 1 2.5 2.5 6 2.5s6-1.5 6-2.5v-5M21 9v5" {...s} /><path d="M10 21v-4h4v4" {...s} opacity={0.4} /></svg>;
}
export function Home({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M3 11l9-7 9 7v9a1 1 0 0 1-1 1h-5v-6h-6v6H4a1 1 0 0 1-1-1z" {...s} /></svg>;
}
export function Store({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M4 9l1-4h14l1 4M4 9v10h16V9M9 19v-5h6v5M4 9c2 2 3 2 5 0s3-2 5 0 3 2 5 0" {...s} /></svg>;
}
export function Warehouse({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M3 21V8l9-4 9 4v13M3 21h18M7 21V12h10v9M9 21v-4h6v4" {...s} /></svg>;
}
export function Library({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M5 21V7l7-4 7 4v14M5 21h14M9 21V11h6v10M3 21h18" {...s} /><path d="M9 14h6M9 17h6" {...s} opacity={0.4} /></svg>;
}
export function MapPin({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M12 2C8 2 5 5 5 9c0 5 7 13 7 13s7-8 7-13c0-4-3-7-7-7z" {...s} /><circle cx="12" cy="9" r="2.5" {...s} /></svg>;
}
export function Compass({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><circle cx="12" cy="12" r="9" {...s} /><path d="M15 9l-2 5-4 1 2-5z" {...s} /></svg>;
}
export function Crosshair({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><circle cx="12" cy="12" r="8" {...s} /><circle cx="12" cy="12" r="3" {...s} /><path d="M12 2v4M12 18v4M2 12h4M18 12h4" {...s} /><circle cx="12" cy="12" r="1" fill="currentColor" /></svg>;
}
export function Satellite({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M5 5l4 4M9 9l-3 3M9 9l3-3M14 14l3-3M14 14l-3 3M14 14l3 3" {...s} /><circle cx="18" cy="6" r="3" {...s} /></svg>;
}
export function Radar({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M12 12L4 4M12 12L20 8M12 12l6 8" {...s} /><circle cx="12" cy="12" r="9" {...s} opacity={0.3} /><circle cx="12" cy="12" r="5" {...s} opacity={0.3} /></svg>;
}
export function Network({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><circle cx="12" cy="12" r="9" {...s} /><path d="M3 12h18M12 3a14 14 0 0 1 0 18M12 3a14 14 0 0 0 0 18" {...s} opacity={0.5} /><circle cx="12" cy="12" r="2" fill="currentColor" /></svg>;
}
export function Globe({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><circle cx="12" cy="12" r="9" {...s} /><path d="M3 12h18M12 3a14 14 0 0 1 0 18M12 3a14 14 0 0 0 0 18" {...s} opacity={0.5} /></svg>;
}
export function Globe2({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><circle cx="12" cy="12" r="9" {...s} /><path d="M3 12h18M12 3a14 14 0 0 1 0 18M12 3a14 14 0 0 0 0 18" {...s} opacity={0.5} /><circle cx="12" cy="12" r="4" {...s} opacity={0.3} /></svg>;
}

export function QrCode({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><rect x="3" y="3" width="7" height="7" rx="1" {...s} /><rect x="14" y="3" width="7" height="7" rx="1" {...s} /><rect x="3" y="14" width="7" height="7" rx="1" {...s} /><path d="M14 14h3v3M20 14v7M14 20h3" {...s} /></svg>;
}

// ── People / Users ──
export function Users({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><circle cx="9" cy="8" r="3" {...s} /><path d="M3 20c0-3.5 3-6 6-6s6 2.5 6 6" {...s} /><circle cx="17" cy="7" r="2.5" {...s} opacity={0.6} /><path d="M17 11c3 0 5 2 5 5" {...s} opacity={0.6} /></svg>;
}
export function User({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><circle cx="12" cy="8" r="3.5" {...s} /><path d="M5 20c0-3.5 3-6 7-6s7 2.5 7 6" {...s} /></svg>;
}
export function UserPlus({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><circle cx="9" cy="8" r="3" {...s} /><path d="M3 20c0-3.5 3-6 6-6s6 2.5 6 6M18 8h3M19.5 6.5v3" {...s} /></svg>;
}
export function UserCheck({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><circle cx="9" cy="8" r="3" {...s} /><path d="M3 20c0-3.5 3-6 6-6s6 2.5 6 6M16 11l2 2 4-4" {...s} /></svg>;
}
export function UserCog({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><circle cx="9" cy="8" r="3" {...s} /><path d="M3 20c0-3.5 3-6 6-6s6 2.5 6 6M18 8a3 3 0 0 1 0 6M18 8v-3M18 14v3" {...s} opacity={0.5} /></svg>;
}
export function Crown({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M3 7l4 4 5-7 5 7 4-4-2 12H5z" {...s} /><path d="M5 19h14" {...s} opacity={0.4} /></svg>;
}
export function Star({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M12 3l2.5 6.5L21 10l-5.5 4 2 7L12 17l-5.5 4 2-7L3 10l6.5-.5z" {...s} /></svg>;
}
export function Award({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><circle cx="12" cy="9" r="5" {...s} /><path d="M9 13l-2 8 5-3 5 3-2-8" {...s} /></svg>;
}
export function Trophy({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M8 4h8v5a4 4 0 0 1-8 0zM8 4H5v2a3 3 0 0 0 3 3M16 4h3v2a3 3 0 0 1-3 3M10 14h4M9 14v5h6v-5" {...s} /></svg>;
}

// ── Finance / Money ──
export function Wallet({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M3 7h15a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7z" {...s} /><path d="M3 7V5a2 2 0 0 1 2-2h11" {...s} /><circle cx="16" cy="13" r="1.5" fill="currentColor" /></svg>;
}
export function Banknote({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><rect x="3" y="6" width="18" height="12" rx="2" {...s} /><circle cx="12" cy="12" r="2.5" {...s} /><path d="M6 9v6M18 9v6" {...s} /></svg>;
}
export function CircleDollarSign({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><circle cx="12" cy="12" r="9" {...s} /><path d="M12 7v10M14 9h-3a2 2 0 0 0 0 4h2a2 2 0 0 1 0 4h-3M12 6v1M12 17v1" {...s} /></svg>;
}
export function PiggyBank({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M4 12a6 6 0 0 1 6-6h4a6 6 0 0 1 6 6v3a3 3 0 0 1-3 3h-1v2l-2-2H9l-2 2v-2a5 5 0 0 1-3-5z" {...s} /><circle cx="16" cy="11" r="1" fill="currentColor" /></svg>;
}
export function Coins({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><circle cx="9" cy="9" r="5" {...s} /><circle cx="15" cy="15" r="5" {...s} opacity={0.5} /><path d="M7 9h4M9 7v4" {...s} opacity={0.4} /></svg>;
}
export function HandCoins({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M7 11l-4 4 3 3 4-4M11 7l4-4 3 3-4 4M14 14l6 6M10 10l4 4" {...s} /><circle cx="17" cy="7" r="2" {...s} opacity={0.4} /></svg>;
}
export function Calculator({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><rect x="5" y="3" width="14" height="18" rx="2" {...s} /><path d="M8 7h8M8 11h2m4 0h2M8 15h2m4 0h2M8 19h2m4 0h2" {...s} /></svg>;
}
export function Scale({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M12 3v18M7 21h10M9 7l-5 9h10zM15 7l-5 9h10zM9 7l3-1 3 1" {...s} /></svg>;
}
export function Percent({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M19 5L5 19" {...s} /><circle cx="7" cy="7" r="2" {...s} /><circle cx="17" cy="17" r="2" {...s} /></svg>;
}

// ── Documents / Files ──
export function FileText({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M6 2h8l4 4v16H6V2z" {...s} /><path d="M14 2v4h4M9 12h6m-6 3h6m-6 3h4" {...s} /></svg>;
}
export function FileCheck({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M6 2h8l4 4v16H6V2z" {...s} /><path d="M14 2v4h4M9 13l2 2 4-4" {...s} /></svg>;
}
export function FileCheck2({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M6 2h8l4 4v16H6V2z" {...s} /><path d="M14 2v4h4" {...s} /><circle cx="17" cy="15" r="4" {...s} /><path d="M15 15l1.5 1.5L20 13" {...s} /></svg>;
}
export function FileArchive({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M6 2h8l4 4v16H6V2z" {...s} /><path d="M14 2v4h4M10 8h2m-2 3h2m-2 3h2" {...s} /></svg>;
}
export function FileSpreadsheet({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M6 2h8l4 4v16H6V2z" {...s} /><path d="M14 2v4h4M9 10h6v8H9zM9 14h6M9 17h6M12 10v8" {...s} /></svg>;
}
export function FileBarChart({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M6 2h8l4 4v16H6V2z" {...s} /><path d="M14 2v4h4M9 16v3M13 13v6M17 10v9" {...s} /></svg>;
}
export function FileCode2({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M6 2h8l4 4v16H6V2z" {...s} /><path d="M14 2v4h4M10 12l-2 2 2 2M14 12l2 2-2 2" {...s} /></svg>;
}
export function ClipboardCheck({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><rect x="5" y="4" width="14" height="18" rx="2" {...s} /><path d="M9 4V3a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v1M9 12l2 2 4-4" {...s} /></svg>;
}
export function ClipboardList({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><rect x="5" y="4" width="14" height="18" rx="2" {...s} /><path d="M9 4V3a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v1M9 10h6M9 14h6M9 18h4" {...s} /></svg>
}
export function Copy({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><rect x="9" y="9" width="12" height="12" rx="2" {...s} /><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" {...s} /></svg>;
}
export function Download({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M12 3v12m6-6l-6 6-6-6M4 21h16" {...s} /></svg>;
}
export function Upload({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M12 21V9m6 6l-6-6-6 6M4 3h16" {...s} /></svg>;
}
export function UploadCloud({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M12 13v8M16 17l-4 4-4-4M7 10a5 5 0 0 1 10 0a4 4 0 0 1 0 8h-3" {...s} /></svg>;
}
export function Printer({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M6 9V3h12v6M6 18H4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-2M6 14h12v7H6z" {...s} /></svg>;
}
export function Save({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M5 3h12l4 4v14H5z" {...s} /><path d="M8 3v5h8M8 15h8v5H8z" {...s} /></svg>
}
export function Pencil({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M3 21l3-1 11-11-2-2L4 18l-1 3z" {...s} /><path d="M14 7l3 3" {...s} /></svg>;
}
export function Edit3({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M3 21l3-1 11-11-2-2L4 18l-1 3zM14 7l3 3M18 3l3 3" {...s} /></svg>;
}
export function Trash2({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M4 7h16M9 7V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2m-9 0v12a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V7M10 11v6m4-6v6" {...s} /></svg>;
}
export function StickyNote({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M4 4h12l4 4v12H4z" {...s} /><path d="M16 4v4h4M8 12h6M8 16h4" {...s} opacity={0.4} /></svg>;
}
export function Pin({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M12 17v5M9 3l6 0M9 3l1 7-3 3h10l-3-3 1-7" {...s} /></svg>;
}
export function ExternalLink({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M14 4h6v6M20 4l-8 8M19 14v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h5" {...s} /></svg>;
}
export function Link2({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M9 15l6-6M10 6l1-1a4 4 0 0 1 6 6l-1 1M14 18l-1 1a4 4 0 0 1-6-6l1-1" {...s} /></svg>;
}
export function History({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M3 12a9 9 0 1 0 3-7M3 4v4h4M12 7v5l3 3" {...s} /></svg>;
}
export function Archive({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><rect x="3" y="4" width="18" height="4" rx="1" {...s} /><path d="M5 8v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V8M10 12h4" {...s} /></svg>;
}

// ── Communication ──
export function Bell({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9M10 21a2 2 0 0 0 4 0" {...s} /></svg>;
}
export function Mail({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><rect x="3" y="5" width="18" height="14" rx="2" {...s} /><path d="M3 7l9 6 9-6" {...s} /></svg>;
}
export function Phone({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M5 4h4l2 5-2.5 1.5a11 11 0 0 0 5 5L15 13l5 2v4a2 2 0 0 1-2 2A16 16 0 0 1 3 6a2 2 0 0 1 2-2z" {...s} /></svg>;
}
export function Send({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M22 2L11 13M22 2l-7 20-4-9-5-4z" {...s} /></svg>;
}
export function MessageSquare({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M4 5h16a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1H9l-4 4v-4H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1z" {...s} /><path d="M8 10h8m-8 3h5" {...s} /></svg>;
}
export function MessageSquarePlus({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M4 5h16a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1H9l-4 4v-4H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1z" {...s} /><path d="M12 8v6M9 11h6" {...s} /></svg>;
}
export function Megaphone({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M3 11l1-5h4l1 5M9 11v6a2 2 0 0 0 4 0v-6M14 11l6-3v10l-6-3" {...s} /></svg>;
}
export function Inbox({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M3 13l3-8h12l3 8M3 13v6a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-6M3 13h5l2 3h4l2-3h5" {...s} /></svg>;
}
export function HelpCircle({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><circle cx="12" cy="12" r="9" {...s} /><path d="M9.5 9a2.5 2.5 0 0 1 5 0c0 2-2.5 2-2.5 4M12 17v.5" {...s} /></svg>;
}
export function Radio({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><circle cx="12" cy="12" r="2" {...s} /><path d="M7 7a7 7 0 0 1 10 0M5 5a11 11 0 0 1 14 0M3 3a15 15 0 0 1 18 0" {...s} opacity={0.5} /></svg>;
}

// ── Charts / Analytics ──
export function TrendingUp({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M3 17l6-6 4 4 8-8" {...s} /><path d="M21 9V5h-4M14 7h7v7" {...s} opacity={0.4} /></svg>;
}
export function TrendingDown({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M3 7l6 6 4-4 8 8" {...s} /><path d="M21 15v4h-4M14 17h7v-7" {...s} opacity={0.4} /></svg>;
}
export function BarChart3({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M4 20V10m5 10V4m5 16v-8m5 8v-5" {...s} /></svg>;
}
export function PieChart({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M12 3a9 9 0 1 0 9 9h-9z" {...s} /><path d="M12 3v9h9" {...s} opacity={0.4} /></svg>;
}
export function LineChart({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M4 20V4M4 20h16" {...s} /><path d="M7 16l3-4 3 2 5-7" {...s} strokeWidth={2} /></svg>;
}
export function Gauge({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M12 17a9 9 0 0 0-9-9M12 17v-2M12 17l-6-3M12 17l-3-6M12 17l3-6M12 17l6-3" {...s} /><circle cx="12" cy="17" r="1.5" fill="currentColor" /></svg>;
}
export function Target({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><circle cx="12" cy="12" r="9" {...s} /><circle cx="12" cy="12" r="5" {...s} /><circle cx="12" cy="12" r="1.5" fill="currentColor" /></svg>;
}
export function MousePointerClick({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M5 3l6 16 2-7 7-2z" {...s} /><path d="M14 7l4 4" {...s} opacity={0.4} /></svg>;
}
export function Bookmark({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M6 3h12v18l-6-4-6 4z" {...s} /></svg>;
}
export function BookmarkPlus({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M6 3h12v18l-6-4-6 4z" {...s} /><path d="M12 8v6M9 11h6" {...s} /></svg>;
}
export function CircleDot({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><circle cx="12" cy="12" r="9" {...s} /><circle cx="12" cy="12" r="1.5" fill="currentColor" /></svg>;
}
export function Hexagon({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M12 3l8 4.5v9L12 21l-8-4.5v-9z" {...s} /></svg>;
}
export function Flag({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M5 21V4M5 4h12l-2 4 2 4H5" {...s} /></svg>;
}

// ── Settings / Tools ──
export function Settings({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><circle cx="12" cy="12" r="3" {...s} /><path d="M12 4v3M12 17v3M4 12h3M17 12h3M6.5 6.5l2 2M15.5 15.5l2 2M17.5 6.5l-2 2M8.5 15.5l-2 2" {...s} /></svg>;
}
export function Settings2({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M4 6h10M4 12h6M4 18h8M18 6l3 3M18 6l-3 3M18 14l3 3M18 14l-3 3" {...s} /></svg>;
}
export function Search({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><circle cx="11" cy="11" r="7" {...s} /><path d="M21 21l-5-5" {...s} /></svg>;
}
export function Filter({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M3 5h18l-7 8v6l-4-2v-4z" {...s} /></svg>;
}
export function Eye({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M2 12s4-7 10-7 10 7-4 7-10 7S2 12 2 12z" {...s} /><circle cx="12" cy="12" r="3" {...s} /></svg>;
}
export function Plus({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M12 5v14M5 12h14" {...s} strokeWidth={1.8} /></svg>;
}
export function Zap({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M13 2L4 14h7l-1 8 9-12h-7z" {...s} /></svg>;
}
export function Wrench({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M14 7a4 4 0 0 0-5 5L3 18l3 3 6-6a4 4 0 0 0 5-5l-2 2-2-2z" {...s} /></svg>;
}
export function Package({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M12 3l8 4.5v9L12 21l-8-4.5v-9z" {...s} /><path d="M4 7.5l8 4.5 8-4.5M12 12v9" {...s} /></svg>;
}
export function PackageCheck({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M12 3l8 4.5v9L12 21l-8-4.5v-9z" {...s} /><path d="M4 7.5l8 4.5 8-4.5" {...s} /><path d="M9 14l2 2 4-4" {...s} /></svg>;
}
export function Maximize2({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M4 9V4h5M20 15v5h-5M4 15v5h5M20 9V4h-5" {...s} /></svg>;
}
export function LayoutDashboard({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><rect x="3" y="3" width="8" height="8" rx="1" {...s} /><rect x="13" y="3" width="8" height="5" rx="1" {...s} /><rect x="13" y="10" width="8" height="11" rx="1" {...s} /><rect x="3" y="13" width="8" height="8" rx="1" {...s} /></svg>;
}
export function LayoutGrid({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><rect x="3" y="3" width="7" height="7" rx="1" {...s} /><rect x="14" y="3" width="7" height="7" rx="1" {...s} /><rect x="3" y="14" width="7" height="7" rx="1" {...s} /><rect x="14" y="14" width="7" height="7" rx="1" {...s} /></svg>;
}
export function Command({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M9 9a3 3 0 1 1 0 6H9V9zM15 9a3 3 0 1 1 0 6v-6zM9 15v3a3 3 0 1 1-6 0M15 15v3a3 3 0 1 0 6 0" {...s} /></svg>;
}
export function Contrast({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><circle cx="12" cy="12" r="9" {...s} /><path d="M12 3a9 9 0 0 0 0 18z" fill="currentColor" opacity={0.3} /></svg>;
}
export function Wand2({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M3 21l5-5M15 5l1-1 3 3-1 1M8 16l8-8M18 3l1 1M5 18l1 1" {...s} /><path d="M14 4l.5 1.5L16 6l-1.5.5L14 8l-.5-1.5L12 6l1.5-.5z" fill="currentColor" opacity={0.4} /></svg>;
}
export function GitBranch({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><circle cx="6" cy="6" r="3" {...s} /><circle cx="6" cy="18" r="3" {...s} /><circle cx="18" cy="9" r="3" {...s} /><path d="M6 9v6M18 12a6 6 0 0 1-6 6" {...s} /></svg>;
}
export function GitCompare({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><circle cx="6" cy="6" r="3" {...s} /><circle cx="18" cy="18" r="3" {...s} /><path d="M6 9v6M18 15V9M9 6h6a3 3 0 0 1 3 3M15 18H9a3 3 0 0 1-3-3" {...s} /></svg>;
}
export function Database({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><ellipse cx="12" cy="5" rx="8" ry="3" {...s} /><path d="M4 5v6c0 1.5 3.5 3 8 3s8-1.5 8-3V5M4 11v6c0 1.5 3.5 3 8 3s8-1.5 8-3v-6" {...s} /></svg>;
}
export function Rocket({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M12 3c4 2 6 6 6 11l-3 3H9l-3-3c0-5 2-9 6-11z" {...s} /><circle cx="12" cy="10" r="2" {...s} /><path d="M9 17l-3 4m9-4l3 4" {...s} /></svg>;
}

// ── Transport / Logistics ──
export function Bus({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M4 16V7a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v9M4 16h16v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-2M8 16v2a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-2M7 8h10v5H7z" {...s} /><circle cx="7.5" cy="16" r="1.2" fill="currentColor" /><circle cx="16.5" cy="16" r="1.2" fill="currentColor" /></svg>;
}
export function Truck({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M3 16V6a1 1 0 0 1 1-1h9a1 1 0 0 1 1 1v10M14 9h4l3 3v4a1 1 0 0 1-1 1h-2M3 16h11" {...s} /><circle cx="7" cy="18" r="2" {...s} /><circle cx="17" cy="18" r="2" {...s} /></svg>;
}
export function Route({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><circle cx="6" cy="6" r="2" {...s} /><circle cx="18" cy="18" r="2" {...s} /><path d="M8 6h6a4 4 0 0 1 4 4v6M6 8v8a4 4 0 0 0 4 4h6" {...s} /></svg>;
}
export function Navigation({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M12 2l3 16-3-3-3 3 3-16z" {...s} /></svg>;
}

// ── Shopping / Commerce ──
export function ShoppingCart({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M3 4h2l2 12h10l2-8H6" {...s} /><circle cx="9" cy="20" r="1.5" {...s} /><circle cx="17" cy="20" r="1.5" {...s} /></svg>;
}
export function ShoppingBag({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M5 8h14l-1 12H6L5 8zM8 8V5a4 4 0 0 1 8 0v3" {...s} /></svg>;
}
export function Tag({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M3 12V5a2 2 0 0 1 2-2h7l9 9-9 9-9-9z" {...s} /><circle cx="8" cy="8" r="1.5" {...s} /></svg>;
}
export function Hash({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M9 3l-1 18M16 3l-1 18M4 8h16M3 16h16" {...s} /></svg>;
}

// ── Education ──
export function GraduationCap({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M2 9l10-4 10 4-10 4-10-4z" {...s} /><path d="M6 11v5c0 1 2.5 2.5 6 2.5s6-1.5 6-2.5v-5M21 9v5" {...s} /></svg>;
}
export function BookOpen({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M12 6c-2-1.5-5-1.5-8 0v14c3-1.5 6-1.5 8 0 2-1.5 5-1.5 8 0V6c-3-1.5-6-1.5-8 0z" {...s} /><path d="M12 6v14" {...s} opacity={0.4} /></svg>;
}
export function Calendar({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><rect x="3" y="5" width="18" height="16" rx="2" {...s} /><path d="M3 9h18M8 3v4m8-4v4M7 14h4v4H7z" {...s} /></svg>;
}
export function CalendarClock({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><rect x="3" y="5" width="18" height="16" rx="2" {...s} /><path d="M3 9h18M8 3v4m8-4v4" {...s} /><circle cx="16" cy="15" r="3" {...s} opacity={0.5} /><path d="M16 14v2" {...s} opacity={0.5} /></svg>;
}

// ── Nature / Food ──
export function Leaf({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M5 17c0-6 4-10 14-10-1 6-4 10-14 10z" {...s} /><path d="M8 14c2-2 5-4 9-5M5 17l-1 3" {...s} opacity={0.5} /></svg>;
}
export function Sun({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><circle cx="12" cy="12" r="4" {...s} /><path d="M12 3v2M12 19v2M3 12h2M19 12h2M5.5 5.5l1.5 1.5M17 17l1.5 1.5M5.5 18.5l1.5-1.5M17 7l1.5-1.5" {...s} /></svg>;
}
export function Moon({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M20 14a8 8 0 0 1-10-10 8 8 0 1 0 10 10z" {...s} /></svg>;
}
export function Coffee({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M5 8h12v6a4 4 0 0 1-4 4H9a4 4 0 0 1-4-4zM17 8h2a2 2 0 0 1 0 6h-2M8 3v2M12 3v2" {...s} /></svg>;
}
export function Apple({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M12 7c-3-1-6 1-6 5s2 8 6 8 6-4 6-8-3-6-6-5z" {...s} /><path d="M12 7c0-1.5.5-3 2-3.5M11 7c-.5-1-1.5-1.5-2.5-1" {...s} opacity={0.4} /></svg>;
}
export function Soup({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M4 8h16v6a8 8 0 0 1-16 0zM4 8l-1-3h3M8 4c0-1 1-2 2-2s2 1 2 2" {...s} /><path d="M7 12c1.5 1 2.5 1 4 0s2.5-1 4 0" {...s} opacity={0.4} /></svg>;
}
export function Utensils({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M5 3v7a2 2 0 0 0 4 0V3M7 10v11M16 3v18M16 7c0-2 1-4 3-4v8" {...s} /></svg>;
}
export function Bed({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M3 18v-8a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v8M3 18h18M3 14h18M7 8V6h4v2" {...s} /></svg>;
}

// ── Tech / Connectivity ──
export function Wifi({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M2 8a15 15 0 0 1 20 0M5 12a10 10 0 0 1 14 0M8.5 15.5a5 5 0 0 1 7 0" {...s} /><circle cx="12" cy="19" r="1" fill="currentColor" /></svg>;
}
export function Lightbulb({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M9 18h6M10 22h4M12 2a7 7 0 0 0-4 12c1 1 1 2 1 3h6c0-1 0-2 1-3a7 7 0 0 0-4-12z" {...s} /></svg>;
}
export function Monitor({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><rect x="3" y="4" width="18" height="12" rx="2" {...s} /><path d="M8 20h8M12 16v4" {...s} /></svg>;
}
export function Smartphone({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><rect x="7" y="2" width="10" height="20" rx="2" {...s} /><path d="M11 18h2" {...s} /></svg>;
}
export function Tablet({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><rect x="4" y="3" width="16" height="18" rx="2" {...s} /><path d="M10 18h4" {...s} /></svg>;
}
export function Palette({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M12 3a9 9 0 1 0 0 18c1 0 2-1 2-2s-1-2-2-2h-1a2 2 0 0 1 0-4 2 2 0 0 1 2-2 2 2 0 0 1 2 2c0 1 1 2 2 2a9 9 0 0 0 5-2" {...s} /><circle cx="8" cy="9" r="1" fill="currentColor" /><circle cx="12" cy="7" r="1" fill="currentColor" /><circle cx="16" cy="9" r="1" fill="currentColor" /></svg>;
}
export function Image({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><rect x="3" y="3" width="18" height="18" rx="2" {...s} /><circle cx="9" cy="9" r="2" {...s} /><path d="M21 15l-5-5L5 21" {...s} /></svg>;
}
export function Type({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M4 7V4h16v3M9 20h6M12 4v16" {...s} /></svg>;
}
export function Layers({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M12 3l9 5-9 5-9-5 9-5z" {...s} /><path d="M3 12l9 5 9-5M3 16l9 5 9-5" {...s} /></svg>;
}
export function Sparkles({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M12 3l1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8L12 3z" {...s} /><path d="M19 15l.7 2L22 17.7l-2.3.7L19 21l-.7-2.6L16 17.7l2.3-.7z" {...s} strokeWidth={1.2} /></svg>;
}
export function Flame({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M12 2c2 4 6 6 6 11a6 6 0 0 1-12 0c0-3 2-5 3-7 1 2 3 3 3-4z" {...s} /></svg>;
}

// ── Utility / Network icons ──
export function Plug({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M9 2v6M15 2v6M7 8h10v3a5 5 0 0 1-10 0z" {...s} /><path d="M12 16v4" {...s} opacity={0.4} /></svg>;
}
export function Power({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M12 4v8" {...s} /><path d="M7 7a7 7 0 1 0 10 0" {...s} /></svg>;
}
export function Signal({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M4 20v-2M9 20v-6M14 20v-10M19 20V8" {...s} /></svg>;
}
export function Router({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><rect x="4" y="12" width="16" height="8" rx="2" {...s} /><path d="M8 16h2M14 16h2M12 12V8M8 8a4 4 0 0 1 8 0" {...s} opacity={0.5} /></svg>;
}
export function Server({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><rect x="3" y="4" width="18" height="7" rx="2" {...s} /><rect x="3" y="13" width="18" height="7" rx="2" {...s} /><path d="M7 7.5h.5M7 16.5h.5" {...s} /></svg>;
}
export function Laptop({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><rect x="4" y="5" width="16" height="10" rx="1" {...s} /><path d="M2 19h20" {...s} /></svg>;
}
export function Pause({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><rect x="6" y="5" width="4" height="14" rx="1" {...s} /><rect x="14" y="5" width="4" height="14" rx="1" {...s} /></svg>;
}
export function Play({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M7 5l12 7-12 7z" {...s} /></svg>;
}
export function Wind({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M3 8h10a3 3 0 1 0-3-3M3 12h14a3 3 0 1 1-3 3M3 16h8" {...s} /></svg>;
}
export function Recycle({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M7 19h-3l3-5M17 19h3l-3-5M12 4l3 5h-6z" {...s} /><path d="M7 19l3-5M17 19l-3-5M12 9v3" {...s} opacity={0.4} /></svg>;
}
export function Battery({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><rect x="2" y="7" width="16" height="10" rx="2" {...s} /><path d="M22 10v4" {...s} /><rect x="4" y="9" width="10" height="6" fill="currentColor" opacity={0.3} /></svg>;
}
export function Snowflake({ size, ...p }: IconProps) {
  return <svg {...base({ size, ...p })}><path d="M12 2v20M4 7l16 10M4 17L20 7" {...s} /><path d="M12 6l-2-2M12 6l2-2M12 18l-2 2M12 18l2 2M5 9l-2-1M5 9l1-2M19 15l2 1M19 15l-1 2" {...s} opacity={0.4} /></svg>;
}

export const ImageIcon = Image;
export const TypeIcon = Type;
